<template>
  <div>
    <!-- header -->
    <div class="fd-head">
      <div class="select-wp">
        <div class="select-box" style="width: 200px">
          <select id="sel_semester" name="">
            <option
              :value="item.Id"
              v-for="(item, idx) in semesterList"
              :key="idx"
            >
              {{ item.Name }} 学期
            </option>
          </select>
        </div>
      </div>
      <h3>企业经济活动国家级虚拟仿真实验教学示范中心</h3>
      <h4>实验室排课数据面板</h4>
      <!-- 链接 -->
      <div class="page-fl">
        <router-link :to="'/data4'">
          <div class="fd-weekbutton">
            <span class="fd-week-ico fd-weekfl"></span>
            <span class="fd-weektext">上一页</span>
          </div>
        </router-link>
      </div>
      <div class="page-fr">
        <router-link :to="'/data2'">
          <div class="fd-weekbutton">
            <span class="fd-weektext">下一页</span>
            <span class="fd-week-ico fd-weekfr"></span>
          </div>
        </router-link>
      </div>
    </div>
    <!-- 课程表-->
    <div class="fd-course-dis">
      <div class="demo-box demo-w mar-bot">
        <div class="title">
          <span class="txt fd-tit">
            <i>{{ semesterName }}</i>
            <i>第{{ seachWeek }}周</i>
            <!-- <span class="fd-weektext" id="test">第{{ seachWeek }}周</span> -->
          </span>
          <div class="line" style="width: 75%">
            <div class="fd-weekbutton">
              <!-- 上一周 <span class="fd-week-ico fd-weekfl"></span> -->
              <span
                class="fd-week-ico fd-weekfl-min"
                v-if="seachWeek > 1"
                @click="WeekChange('minus')"
              ></span>
              <span
                class="fd-week-ico fd-weekfl-stop-min"
                v-if="seachWeek == 1"
              ></span>
              <span
                v-if="seachWeek > 1"
                class="fd-weektext"
                style="margin-left: 5px; cursor: pointer; user-select: none"
                @click="WeekChange('minus')"
                >上一周</span
              >
              <span
                class="fd-weektext"
                style="margin-left: 5px; user-select: none; color: #aaa"
                v-if="seachWeek == 1"
                >上一周</span
              >
              <span
                v-if="seachWeek < weekInfo.weeks"
                class="fd-weektext"
                style="
                  margin-right: 5px;
                  margin-left: 30px;
                  cursor: pointer;
                  user-select: none;
                "
                @click="WeekChange('plus')"
                >下一周</span
              >
              <span
                v-if="seachWeek >= weekInfo.weeks"
                class="fd-weektext"
                style="
                  margin-right: 5px;
                  margin-left: 30px;
                  user-select: none;
                  color: #aaa;
                "
                >下一周</span
              >
              <span
                class="fd-week-ico fd-weekfr-min"
                v-if="seachWeek < weekInfo.weeks"
                @click="WeekChange('plus')"
              ></span>
              <span
                class="fd-week-ico fd-weekfr-stop-min"
                v-if="seachWeek >= weekInfo.weeks"
              ></span>
              <!-- 最后一周 <span class="fd-week-ico fd-weekfr-stop"></span> -->
            </div>
          </div>
        </div>
        <div class="content">
          <div class="fd-course">
            <table>
              <thead>
                <tr v-if="seachWeek > 0">
                  <th></th>
                  <th :class="weekDay == 1 ? 'bg-change' : ''">
                    <span>星期一</span>
                    <i>{{ weekDayFormat(seachWeek, 0) }}</i>
                  </th>
                  <th :class="weekDay == 2 ? 'bg-change' : ''">
                    <span>星期二</span>
                    <i>{{ weekDayFormat(seachWeek, 1) }}</i>
                  </th>
                  <th :class="weekDay == 3 ? 'bg-change' : ''">
                    <span>星期三</span>
                    <i>{{ weekDayFormat(seachWeek, 2) }}</i>
                  </th>
                  <th :class="weekDay == 4 ? 'bg-change' : ''">
                    <span>星期四</span>
                    <i>{{ weekDayFormat(seachWeek, 3) }}</i>
                  </th>
                  <th :class="weekDay == 5 ? 'bg-change' : ''">
                    <span>星期五</span>
                    <i>{{ weekDayFormat(seachWeek, 4) }}</i>
                  </th>
                  <th :class="weekDay == 6 ? 'bg-change' : ''">
                    <span>星期六</span>
                    <i>{{ weekDayFormat(seachWeek, 5) }}</i>
                  </th>
                  <th :class="weekDay == 0 ? 'bg-change' : ''">
                    <span>星期日</span>
                    <i>{{ weekDayFormat(seachWeek, 6) }}</i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(cl, i) in classlist">
                  <tr v-if="i < 8 && i % 2 == 0" :key="cl.Id">
                    <td>
                      <div class="resize resize-num">
                        {{ cl.Number }}~{{ cl.Number + 1 }}节
                      </div>
                    </td>
                    <td
                      v-for="(wd, index) in weekdays"
                      :key="index"
                      :class="weekDay == index + 1 ? 'cur' : ''"
                    >
                      <div class="resize">
                        <div
                          class="fd-course-name"
                          v-for="d in pagedata.filter((v) => {
                            return (
                              (v.BusinessCourseId > 0 &&
                                v.WeekDay == wd &&
                                ((v.StartLesson <= cl.Number &&
                                  v.EndLesson >= cl.Number) ||
                                  (v.StartLesson <= cl.Number + 1 &&
                                    v.EndLesson >= cl.Number + 1))) ||
                              (v.ActivityId > 0 &&
                                v.WeekDay == wd &&
                                isDateIntersection(
                                  v.StartTime,
                                  v.EndTime,
                                  v.Date,
                                  cl.StartTime,
                                  classlist.find(
                                    (v) => v.Number == cl.Number + 1
                                  ).EndTime
                                ))
                            );
                          })"
                          :key="d.Id"
                        >
                          <template v-if="d.BusinessCourseId > 0">
                            <i>@{{ d.LaboratoryCode }}</i>
                            <span>{{ d.CourseName }}</span>
                          </template>
                          <template v-if="d.ActivityId > 0">
                            <i>@{{ d.LaboratoryCode }}</i>
                            <span>{{ d.ActivityName }}</span>
                          </template>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="i == 10" :key="cl.Id">
                    <td>
                      <div class="resize resize-num">
                        {{ cl.Number - 2 }}~{{ cl.Number }}节
                      </div>
                    </td>
                    <td
                      v-for="(wd, index) in weekdays"
                      :key="index"
                      :class="weekDay == index + 1 ? 'cur' : ''"
                    >
                      <div class="resize">
                        <div
                          class="fd-course-name"
                          v-for="d in pagedata.filter((v) => {
                            return (
                              (v.BusinessCourseId > 0 &&
                                v.WeekDay == wd &&
                                (v.EndLesson == cl.Number - 2 ||
                                  v.EndLesson == cl.Number - 1 ||
                                  v.EndLesson == cl.Number)) ||
                              (v.ActivityId > 0 &&
                                v.WeekDay == wd &&
                                isDateIntersection(
                                  v.StartTime,
                                  v.EndTime,
                                  v.Date,
                                  classlist.find(
                                    (v) => v.Number == cl.Number - 2
                                  ).StartTime,
                                  cl.EndTime
                                ))
                            );
                          })"
                          :key="d.Id"
                        >
                          <template v-if="d.BusinessCourseId > 0">
                            <i>@{{ d.LaboratoryCode }}</i>
                            <span>{{ d.CourseName }}</span>
                          </template>
                          <template v-if="d.ActivityId > 0">
                            <i>@{{ d.LaboratoryCode }}</i>
                            <span>{{ d.ActivityName }}</span>
                          </template>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
  </div>
</template>

<script>
import $ from '../../static/js/jquery.min.js'
import jQuery from '../../static/js/selectordie.min.js'
import axios from 'axios'
import moment from 'moment'
import {
  getApi
} from '../../static/js/api.js'
export default {
  data () {
    return {
      semesterId: 0,
      semesterName: '',
      seachWeek: 0,
      pagedata: [],
      classlist: [],
      weekInfo: {},
      weekdays: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      semesterList: []
    }
  },
  computed: {
    weekDay: function () {
      return moment().day()
    }
  },
  mounted () {
    let that = this
    this.resizeH()
    $(window).resize(function () {
      that.resizeH()
    })

    this.getSemesterList()

    getApi('/Lesson/GetAll').then(res => {
      if (res.IsSuccess) {
        that.classlist = res.SuccessData
      }
    })
    this.GetNowSemesterAndWeek()
  },
  methods: {
    moment,
    resizeH () {
      var resizeH = document.body.clientHeight - 364;
      $(".resize").height(resizeH / 5);
    },
    GetNowSemesterAndWeek (semesterId) {
      if (!semesterId) {
        semesterId = 0
      }

      getApi('/bi/GetNowSemesterAndWeek', { semesterId: semesterId }, 'Post').then(res => {
        if (res.IsSuccess) {
          this.weekInfo = this.WeekInfo(moment(res.SuccessData.Semester.Begin_Date), moment(res.SuccessData.Semester.End_Date))

          this.semesterName = res.SuccessData.Semester.Name
          this.semesterId = res.SuccessData.Semester.Id
          this.seachWeek = res.SuccessData.Week > this.weekInfo.weeks ? (semesterId > 0 ? 1 : this.weekInfo.weeks) : res.SuccessData.Week
        }
        this.serch()
      })
    },
    getSemesterList () {
      let that = this
      getApi('/Semester/GetAll').then(res => {
        if (res.IsSuccess) {
          this.semesterList = res.SuccessData
          setTimeout(() => {
            $("select").selectOrDie()
            $("#sel_semester").change(function () {
              that.GetNowSemesterAndWeek($(this).find('option:selected').val())
            })
          }, 500)
        }
      })
    },
    serch () {
      let that = this
      getApi('/BusinessCourseArrangement/GetList', {
        pagesize: 19999 * 9999,
        page: 1,
        SemesterId: that.semesterId,
        CourseId: 0,
        LaboratoryId: 0,
        weeks: that.seachWeek,
        status: 0,
        isSearchMine: that.serchMine ? 1 : 0
      }, 'Post').then(res => {
        if (res.IsSuccess) {
          that.pagedata = []

          res.SuccessData.data.forEach((v, i) => {
            var rs = that.pagedata.filter(pd => {
              if (v.BusinessCourseId > 0) {
                return (
                  pd.BusinessCourseId == v.BusinessCourseId &&
                  pd.Laboratory == v.Laboratory &&
                  pd.WeekDay == v.WeekDay &&
                  pd.StartLesson == v.StartLesson &&
                  pd.EndLesson == v.EndLesson &&
                  pd.StartTime.substr(11, 8) == v.StartTime.substr(11, 8) &&
                  pd.EndTime.substr(11, 8) == v.EndTime.substr(11, 8)
                )
              } else {
                return (
                  pd.ActivityId == v.ActivityId &&
                  pd.Laboratory == v.Laboratory &&
                  pd.WeekDay == v.WeekDay &&
                  pd.StartTime.substr(11, 8) == v.StartTime.substr(11, 8) &&
                  pd.EndTime.substr(11, 8) == v.EndTime.substr(11, 8)
                )
              }
            })
            if (rs.length > 0) {
              rs[0].Weekstr = rs[0].Weekstr + ',' + v.Week
              let arr = rs[0].Weekstr.split(',')
                .sort((v1, v2) => {
                  return parseInt(v1) - parseInt(v2)
                })
                .map(v => parseInt(v))
            } else {
              v.Weekstr = v.Week.toString()
              let arr = v.Weekstr.split(',')
                .sort((v1, v2) => {
                  return parseInt(v1) - parseInt(v2)
                })
                .map(v => parseInt(v))
              that.pagedata.push(v)
            }
          })
          that.resizeH()
        }
      })
    },
    WeekInfo: function (start, end) {
      var info = {}
      info.weeks = 0
      info.list = []
      if (start === undefined || start === '') {
        return info
      }
      var s = ''
      while (end >= start) {
        if (s == '') {
          s = moment(start)
        }
        if (start.weekday() == 0 || start.format('YYYY-MM-DD') == end.format('YYYY-MM-DD')) {
          info.weeks += 1

          info.list.push({
            start: s.format('YYYY-MM-DD'),
            end: start.format('YYYY-MM-DD')
          })
          s = ''
        }
        start = start.add(1, 'days')
      }

      console.log(info)
      return info
    },
    isDateIntersection (start1, end1, date, start2, end2) {
      var startdate1 = new Date(start1.replace('T', ' '))
      var enddate1 = new Date(end1.replace('T', ' '))

      var startdate2 = new Date(date.replace('T', ' ').substr(0, 10) + ' ' + start2)
      var enddate2 = new Date(date.replace('T', ' ').substr(0, 10) + ' ' + end2)

      if (startdate1 >= startdate2 && startdate1 <= enddate2) {
        return true
      }

      if (enddate1 >= startdate2 && enddate1 <= enddate2) {
        return true
      }

      if (startdate1 <= startdate2 && enddate1 >= enddate2) {
        return true
      }
      return false
    },
    weekDayFormat (weekNum, idx) {
      let start = moment(this.weekInfo.list[weekNum - 1].start)
      let end = moment(this.weekInfo.list[weekNum - 1].end)
      return end.add(start.diff(end, 'day') + idx, 'd').format('MM-DD')
    },
    WeekChange (option) {
      if (option == 'plus') {
        this.seachWeek++
      } else {
        this.seachWeek--
      }
      this.serch()
    }
  }
}
</script>

<style>
.semesterName {
  z-index: 99;
  position: absolute;
  top: 66px;
  color: rgb(255, 255, 255);
  left: 39%;
  transform: translate(-50%, 0px);
  vertical-align: middle;
  font: 18px / 32px "Microsoft YaHei";
  background: #00000000;
  border: #457ba3 solid 2px;
  border-radius: 4px;
  height: 32px;
}
.fd-weekfl-min {
  background-position: -23px -20px;
  width: 22px;
  cursor: pointer;
}
.fd-weekfl-stop-min {
  background-position: -175px -20px;
  width: 19px;
}

.fd-weekfr-min {
  background-position: -117px -20px;
  width: 22px;
  cursor: pointer;
}
.fd-weekfr-stop-min {
  background-position: -267px -20px;
  width: 20px;
}
</style>
